import cls from "classnames";
import { useTranslation } from "react-i18next";
import { DialogContext } from "./DialogContext";
import styles from "./index.module.scss";
import { useRequiredContext } from "contexts/utils";

type HeaderProps = {
  className?: string;
};

function CloseButton({ className }: HeaderProps) {
  const { onClose } = useRequiredContext(DialogContext);
  const { t } = useTranslation();
  return (
    <button
      type="button"
      className={cls(styles.close, "talaera-dialog-close", className)}
      onClick={onClose}
      aria-label={t("Common.actions.close")}
    >
      ✕
    </button>
  );
}

/** Title on the left, ✕ on the right. The shape most dialogs want. */
export function DefaultDialogHeader(props: HeaderProps) {
  const { title } = useRequiredContext(DialogContext);
  return (
    <header className={cls(styles.head, props.className)}>
      <h3 className={styles.title}>{title}</h3>
      <CloseButton />
    </header>
  );
}

/** Title centered between the ✕ and a spacer mirroring it — the wizard look. */
export function CenteredDialogHeader(props: HeaderProps) {
  const { title } = useRequiredContext(DialogContext);
  return (
    <header className={cls(styles.head, styles.headCentered, props.className)}>
      {/* Mirrors the close button so the title stays optically centered. */}
      <span className={styles.edgeSpacer} aria-hidden />
      <h3 className={cls(styles.title, styles.titleCentered)}>{title}</h3>
      <CloseButton />
    </header>
  );
}

/**
 * No title bar — just a ✕ floated into the panel's corner, for bodies that own
 * the whole composition. The dialog is still named: the panel takes its name
 * from `title` directly, so nothing has to be rendered to carry it.
 */
export function BasicDialogHeader(props: HeaderProps) {
  return <CloseButton className={cls(styles.insideClose, props.className)} />;
}
